import { FC } from "react";
import orderOptimizerHelper from "../../../../../../common/order-optimizer.helper";
import LinkButtonComponent from "../../../../../../../../common/components/button/link/link-button.component";
import dateService from "../../../../../../../../common/utils/date/date.service";
import orderRoutesHelper from "../../../../../../../order/common/routes/order-routes.helper";
import orderOptimizerCargoDetailsHiddenDetailsOrdersOrderSummaryHelper from "./order-optimizer-cargo-details-hidden-details-center-tables-orders-order-summary.helper";
import { OrderOptimizerCargoDetailsItemOrders } from "../../../../common/types/order-optimizer-cargo-details-item";
import orderOptimizerCargoDetailsHelper from "../../../../order-optimizer-cargo-details.helper";

type OrderOptimizerCargoDetailsHiddenDetailsCenterTablesOrdersOrderSummaryProps =
  {
    order: OrderOptimizerCargoDetailsItemOrders;
    orderIndex: number;
  };

const OrderOptimizerCargoDetailsHiddenDetailsCenterTablesOrdersOrderSummaryComponent: FC<
  OrderOptimizerCargoDetailsHiddenDetailsCenterTablesOrdersOrderSummaryProps
> = (props) => {
  const dotColor = orderOptimizerHelper.getOrderColor(props.orderIndex);
  const currentDate = new Date();
  const startTime = new Date(props.order.startTime);

  const orderIdTitle =
    orderOptimizerCargoDetailsHiddenDetailsOrdersOrderSummaryHelper.getOrderIdTitle(
      props.order.humanId
    );
  const orderIdLabel =
    orderOptimizerCargoDetailsHiddenDetailsOrdersOrderSummaryHelper.getOrderIdLabel(
      props.order.humanId
    );

  const timeDifferenceInSeconds = Math.max(
    Math.floor((startTime.getTime() - currentDate.getTime()) / 1000),
    0
  );

  const startTimeString = orderOptimizerCargoDetailsHelper.getTimeDeltaLabel(
    timeDifferenceInSeconds
  );

  const startUntilTitle =
    orderOptimizerCargoDetailsHiddenDetailsOrdersOrderSummaryHelper.getStartTimeTitle(
      startTimeString
    );
  const startUntilLabel =
    orderOptimizerCargoDetailsHiddenDetailsOrdersOrderSummaryHelper.getStartTimeLabel(
      startTimeString
    );

  const startDateTitle = dateService.formatDate(props.order.startTime);
  const startDateLabel = dateService.formatDate(props.order.startTime);

  return (
    <div className="order_summary">
      <div className="order_id">
        <div
          className="dot"
          style={{
            backgroundColor: dotColor,
          }}
        />
        <LinkButtonComponent
          openInNewTab
          to={orderRoutesHelper.getListingOfActiveOrdersRoute({
            internalOrderId: String(props.order.humanId),
          })}
        >
          <div className="text" title={orderIdTitle}>
            {orderIdLabel}
          </div>
        </LinkButtonComponent>
      </div>
      <div title={props.order.billingModel}>{props.order.billingModel}</div>
      <div title={props.order.taxiCorporation}>
        {props.order.taxiCorporation}
      </div>
      <div title={startUntilTitle}>{startUntilLabel}</div>
      <div title={startDateTitle}>{startDateLabel}</div>
    </div>
  );
};

export default OrderOptimizerCargoDetailsHiddenDetailsCenterTablesOrdersOrderSummaryComponent;
